let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fp083")).then(() => parcelRequire('61OeS'));